import HNSColors from "../../../../ui library/HNSColors";

export const initialRequiredFields = {
  source: false,
  provider: false,
  referralFrom: false,
  referralTo: false,
  documentType: true,
  file: true,
};

export const initialObj = {
  documentType: null,
  file: null,
  fileName: "",
  id: "",
  provider: null,
  referralFrom: null,
  referralTo: null,
  source: null,
};

export const initialOpts = {
  docTypeOptions: [],
  sourceOptions: [],
  providerOptions: [],
  referralFromOptions: [],
  referralToOptions: [],
  documentValidation: null,
  maxFileSize: "Max Size: 100MB",
};

export const fieldMappings = (formData) => {
  return [
    {
      key: "file",
      bodyKey: "file",
      externalKey: "file",
      compareFunction: (initial, current) => JSON.stringify(initial) !== JSON.stringify(current),
      extraFields: { fileName: formData.fileName },
    },
    {
      key: "documentType",
      bodyKey: "document_type",
      externalKey: "documentType",
    },
    {
      key: "source",
      bodyKey: "source",
      externalKey: "source",
    },
    {
      key: "provider",
      bodyKey: "provider",
      externalKey: "provider",
    },
    {
      key: "referralFrom",
      bodyKey: "referral_from",
      externalKey: "referralFrom",
    },
    {
      key: "referralTo",
      bodyKey: "referral_to",
      externalKey: "referralTo",
    },
  ];
};

export const textFieldStyles = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "8px",
    "& fieldset": {
      borderRadius: "8px",
    },
    "&:hover fieldset": {
      borderRadius: "8px",
    },
    "&.Mui-focused fieldset": {
      borderRadius: "8px",
    },
    "&.Mui-disabled": {
      backgroundColor: HNSColors.neutrals[800],
    },
  },
  "& .MuiAutocomplete-root .MuiOutlinedInput-root.Mui-disabled": {
    backgroundColor: HNSColors.neutrals[800],
  },
};

export const clearButtonStyles = {
  color: HNSColors.secondary[500],
  border: `1px solid ${HNSColors.secondary[500]}`,
  "&:hover": {
    background: HNSColors.secondary[900],
    border: `1px solid ${HNSColors.secondary[500]}`,
  },
};

export const uploadButtonStyles = {
  background: HNSColors.secondary[500],
  "&:hover": {
    background: HNSColors.secondary[600],
  },
};

export const searchableFields = [
  {
    label: "Document Type",
    key: "documentType",
    optsKey: "docTypeOptions",
  },
  {
    label: "Document Source",
    key: "source",
    optsKey: "sourceOptions",
  },
  {
    label: "Provider",
    key: "provider",
    optsKey: "providerOptions",
    enableSearchQuery: true,
  },
  {
    label: "Referral From",
    key: "referralFrom",
    optsKey: "referralFromOptions",
    enableSearchQuery: true,
  },
  {
    label: "Referral To",
    key: "referralTo",
    optsKey: "referralToOptions",
    enableSearchQuery: true,
  },
];

export const dynamicFieldOptionsMap = {
  provider: "providerOptions",
  referralFrom: "referralFromOptions",
  referralTo: "referralToOptions",
};

const dynamicFieldKeys = ["provider", "referralFrom", "referralTo"];

export const initialDynamicFieldSearch = dynamicFieldKeys.reduce((acc, key) => {
  acc[key] = "";
  return acc;
}, {});

export const initialDynamicFieldInputValues = dynamicFieldKeys.reduce((acc, key) => {
  acc[key] = null;
  return acc;
}, {});

export const SEARCH_DEBOUNCE_DELAY = 300;

export const initialDynamicFieldFirstLoad = dynamicFieldKeys.reduce((acc, key) => {
  acc[key] = true;
  return acc;
}, {});

export const DYNAMIC_FIELD_INITIAL_LIMIT = 25;
export const DYNAMIC_FIELD_LIMIT_INCREMENT = 100;
